import * as React                                         from 'react';
import { v4 as uuidv4                                   } from 'uuid';
import { useTheme                                       } from 'styled-components';

import { LinkBlankVector                                } from 'src/components/vector/linkblank';
import { ArrowBackVector                                } from 'src/components/vector/arrow-back';
import { StickyNotesVector                              } from 'src/components/vector/sticky-notes';
import { ErrorOutlineVector                             } from 'src/components/vector/error-outline';
import { FrontRecommendationVector                      } from 'src/components/vector/recommenadtions/front-recommendadtion';
import { FrontWrongFirstVector                          } from 'src/components/vector/recommenadtions/front-wrong-first';
import { FrontWrongSecondVector                         } from 'src/components/vector/recommenadtions/front-wrong-second';
import { SideRecommendationVector                       } from 'src/components/vector/recommenadtions/side-recommendation';
import { SideWrongFirstVector                           } from 'src/components/vector/recommenadtions/side-wrong-first';
import { SideWrongSecondVector                          } from 'src/components/vector/recommenadtions/side-wrong-second';

import { TabItem, Tabs                                  } from 'src/components/common/tabs';
import { Typography                                     } from 'src/components/common/typography';
import { Link                                           } from 'src/components/common/link';

import { NavBar                                         } from 'src/components/features/common/nav-bar';
import { Toolbar                                        } from 'src/components/features/main/common/toolbar';

import { RequirementsAndRecommendationsElementLayout, 
  layout_dark, 
  layout_light,
  Screen, 
  ScreenBody,
  InfoContainer,
  RequirementsContainer,
  LinkContainer,
  RequirementsItem,
  IconContainer,
  ViewContainer,
  WrongContainer,                                       } from 'src/containers/main/requirements-and-recommendations/layout';

import { Urls                                           } from 'src/providers/routing';

import { AppDispatch, useAppDispatch                    } from 'src/store';



type RequirementsAndRecommendationsElement = {
    layout: RequirementsAndRecommendationsElementLayout;
    dispatch: AppDispatch;
};
  
const Navigation: React.FC<RequirementsAndRecommendationsElement> = ({
    layout,
  }) => {
    return (
      <React.Fragment>
        <NavBar
          variant = { layout.navbarVariant }
          label = 'Требования и рекомендации'
          startButtons = {[
            {
              id: 'back',
              vector: <ArrowBackVector />,
              action: () => Urls.MainProductCounter.build().navigate(),
            },
          ]}
        />
      </React.Fragment>
    );
};

const tabs = [
  { id: 'requirements', label: 'Требования' }, 
  { id: 'recommendations', label: 'Рекомендации' }
];

const requirements = [
  'Разрешение фото не менее 12 Мп.',
  'Фото сделано в режиме максимального качества, не использован цифровой зум',
  'Целевой объект (пачка стали) находится в фокусе',
  'Целевой объект (пачка стали) занимает не менее 80% изображения и находится во фронтальной плоскости',
  'Листы в пачке лежат ровно без смещений',
];

type RequirementsProps = {
  layout: RequirementsAndRecommendationsElementLayout;
};

const Requirements: React.FC<RequirementsProps> = ({ layout }) => {
  return (
    <React.Fragment>
      <InfoContainer layout = { layout }>
        <ErrorOutlineVector/>
        <Typography variant = 'blackw400s12lh14'>
          Для корректной работы алгоритма подсчета необходимо выполнение условий
        </Typography>
      </InfoContainer>
      <RequirementsContainer layout = { layout }>
        {requirements.map((el, i) => (
          <RequirementsItem key = { uuidv4() }>
            <Typography variant = 'blackw400s14lh20'>
              { i + 1 }. { el }
            </Typography>
          </RequirementsItem>
        ))}
      </RequirementsContainer>
      <LinkContainer layout = { layout }>
        <IconContainer layout = { layout }>
          <LinkBlankVector/>
        </IconContainer>
        <Link variant = 'blue13' label = 'Открыть пример фото' onTap={() => Urls.MainProductCounterPhotoExample.build().navigate()}/>
      </LinkContainer>
    </React.Fragment>
  )
}

type RecommendationsProps = {
  layout: RequirementsAndRecommendationsElementLayout;
};

const Recommendations: React.FC<RecommendationsProps> = ({ layout }) => {
  return (
    <React.Fragment>    
      <InfoContainer layout = { layout }>
        <StickyNotesVector/>
        <Typography variant = 'blackw400s12lh14'>
          Ниже приведены иллюстрации того, как необходимо распологать камеру в момент снимка
        </Typography>
      </InfoContainer>
      <ViewContainer layout = { layout }>
        <Typography variant = 'steelw500s12lh16'>
          Вид сбоку
        </Typography>
        <FrontRecommendationVector/>
        <WrongContainer layout = { layout }>
          <FrontWrongFirstVector/>
          <FrontWrongSecondVector/>
        </WrongContainer>
      </ViewContainer>
      <ViewContainer layout = { layout }>
        <Typography variant = 'steelw500s12lh16'>
          Вид с фронтальной камеры
        </Typography>
        <SideRecommendationVector/>
        <WrongContainer layout = { layout }>
          <SideWrongFirstVector />
          <SideWrongSecondVector />
        </WrongContainer>
      </ViewContainer>
    </React.Fragment>
  )
}

export const RequirementsAndRecommendations = () => {
  const theme = useTheme();
  const layout = theme.colorScheme === 'light' ? layout_light : layout_dark;
  const dispatch = useAppDispatch();

  const [tab, setTab] = React.useState(tabs[0])

  const handleChenge = (value: TabItem) => {
    setTab(value);
  }

  const render = (id: string) => {
    switch (id)
    {
      case 'requirements':
        return <Requirements layout = { layout }/>
      case 'recommendations':
        return <Recommendations layout = { layout }/>
      default:
        break;
    }
  }

  return (
    <Screen layout = { layout }>
      <Navigation layout = { layout } dispatch = { dispatch }/>
      <Tabs
        variant = 'h52'
        items = { tabs }
        value = { tab }
        onChange = { handleChenge }
      />
      <ScreenBody layout = { layout }>
        { render(tab.id) }     
      </ScreenBody>
      <Toolbar variant = { layout.toolbarVariant } activeItem = 'services' />
    </Screen>
  )
}